<div #tooltip [class]="getClasses()" data-testid="tooltip-container" role="tooltip">
  @if (template()) {
    <div class="tooltip__complex">
      <ng-container *ngTemplateOutlet="template(); context: templateContext() ?? null" />
    </div>
  } @else {
    <span class="tooltip__text">{{ message() }}</span>
  }
  <span class="tooltip__chevron" [style]="indicatorPositionStyle()"></span>
</div>
